import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Mail, ArrowLeft } from 'lucide-react';
import { authAPI } from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await authAPI.forgotPassword(email);
      setMessage(response.message);
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to send reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%)',
      padding: '24px 16px',
      boxSizing: 'border-box',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Soft Ambient Background Glow */}
      <div style={{
        position: 'absolute',
        top: '20%',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '480px',
        height: '480px',
        background: 'radial-gradient(circle, rgba(5, 150, 105, 0.08) 0%, rgba(248, 250, 252, 0) 70%)',
        pointerEvents: 'none',
        zIndex: 0
      }} />

      <Card style={{
        width: '100%',
        maxWidth: '420px',
        backgroundColor: '#ffffff',
        boxShadow: '0 20px 40px -15px rgba(15, 23, 42, 0.10), 0 0 1px 1px rgba(15, 23, 42, 0.04)',
        border: '1px solid #e2e8f0',
        borderRadius: '16px',
        position: 'relative',
        zIndex: 1
      }}>
        <CardHeader className="space-y-1 text-center" style={{ padding: '24px 24px 12px' }}>
          <div className="mx-auto mb-2 flex items-center justify-center">
            <img 
              src="/assets/nutrimus-logo.png" 
              alt="NUTRIMUS" 
              style={{ height: '70px', width: 'auto', objectFit: 'contain' }}
            />
          </div>
          <CardTitle className="text-xl font-bold tracking-tight text-slate-900">Lupa Password</CardTitle>
          <CardDescription className="text-xs text-slate-500">
            Masukkan alamat email terdaftar untuk menerima tautan reset password
          </CardDescription>
        </CardHeader>
        <CardContent style={{ padding: '8px 24px 24px' }}>
          <form onSubmit={handleSubmit} className="space-y-4">
            {message && (
              <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 px-3.5 py-2.5 rounded-xl text-xs">
                {message}
              </div>
            )}
            
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-800 px-3.5 py-2.5 rounded-xl text-xs">
                {error}
              </div>
            )}

            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-xs font-semibold text-slate-700">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-3 h-4 w-4 text-slate-400" />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="nama@email.com"
                  className="pl-9 h-10 text-xs bg-slate-50/80 border-slate-300 focus-visible:ring-emerald-500"
                  required
                />
              </div>
            </div>

            <Button 
              type="submit" 
              className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold h-10 rounded-xl shadow-md shadow-emerald-600/25 transition-all text-xs" 
              disabled={loading}
            >
              {loading ? 'Mengirim tautan...' : 'Kirim Tautan Reset Password'}
            </Button>

            <Button
              type="button"
              variant="ghost"
              className="w-full text-xs text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-xl h-9"
              onClick={() => navigate('/')}
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Kembali ke Halaman Login
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
